import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default class ContentColumns {
  constructor() {
    this.selector = '.b-af-content-columns';

    this.blocks = Array.from(document.querySelectorAll(this.selector));

    if (this.blocks.length === 0) {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    this.classNames = {
      item: 'b-af-content-columns__item',
    }

    this.bootstrap();
  }

  bootstrap() {
    this.blocks.forEach(block => {
      this.initBlock(block);
    });
  }

  initBlock(block) {
    const items = Array.from(block.querySelectorAll(`.${this.classNames.item}`));

    if (items.length === 0) {
      return;
    }

    gsap.fromTo(items,
      { opacity: 0, y: 10 },
      {
        duration: 0.5,
        opacity: 1,
        scrollTrigger: { start: 'top+=200 bottom', trigger: block },
        stagger: 0.1,
        y: 0,
      }
    );

    this.itemsButtonModalPosition(items);
  }

  itemsButtonModalPosition(items) {
    items.forEach((item) => {
      const modalButton = item.querySelector('.b-af-content-columns__item-cta');
      const modal = item.querySelector('.modal, .modal-content-close');

      if (modal) {
        modalButton.addEventListener('click', () => {
          item.style.transform = '';
        });

        modal.addEventListener('click', (event) => {
          setTimeout(() => {
            if (event.target == modal) {
              item.style.transform = 'translate(0px)';
            }
          }, 500);
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/contentColumns.js